export default __webpack_public_path__ + "static/media/icon-table-idg.31c9347c.svg";